// Modified App.js
import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import BestSeller from './components/BestSeller';
import Gallery from './components/Gallery';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Slogan from './components/Slogan';
import Story from './components/Story';
import BrandingPage from './components/BrandingPage';
import { Routes, Route } from 'react-router-dom';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';

const App = () => {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Slogan/>
              <BestSeller />
              
              <Story />
              {/* <Gallery /> */}
              <Benefits />
              <Testimonials />
              {/* <BrandingPage /> */}
              <Contact />
            </>
          }
        />
        <Route path="/san-pham" element={<ProductsPage />} />
        <Route path="/san-pham/:slug" element={<ProductsPage />} />
        <Route path="/san-pham/chi-tiet/:id" element={<ProductDetailPage />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;